import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const ticketService = { constants, slice, sagas };

export default ticketService;

